import VIPLanding from './VIPLanding';

export default VIPLanding;
